export default __webpack_public_path__ + "static/media/mautic4.43671038.svg";